import { Platform } from 'react-native';

const televisionPlatformNames = new Set([
    'androidtv',
    'firetv',
    'tizen',
    'tvos',
    'webos',
    'webtv',
    'xbox',
]);
const webTelevisionModeKey = 'jellyflix.web.television-mode.v1';

// Captured once before navigation rewrites the URL, so TV preview remains
// active while the reviewer searches and navigates within the Web session.
const forcedTelevisionPreview = (() => {
    try {
        return new URLSearchParams(window.location.search).get('tv') === '1';
    } catch {
        return false;
    }
})();

function preferredTelevisionPresentation() {
    try {
        return window.localStorage.getItem(webTelevisionModeKey) === 'true';
    } catch {
        return false;
    }
}

export function isTelevisionRuntime() {
    return forcedTelevisionPreview
        || preferredTelevisionPresentation()
        || Boolean(Platform.isTV)
        || televisionPlatformNames.has(String(Platform.OS).toLowerCase());
}

export function setWebTelevisionMode(enabled: boolean) {
    try {
        window.localStorage.setItem(webTelevisionModeKey, enabled ? 'true' : 'false');
    } catch {
        // Storage can be unavailable in hardened/private browser contexts. The
        // preference still remains in Jellyflix settings for the next session.
    }
}
